// Actions
export const setOverview = ({ commit }, payload) => {
  commit('SET_OVERVIEW', payload)
}
export const addOverview = ({ commit }, payload) => {
  commit('ADD_OVERVIEW', payload)
}
export const setOverviewLoading = ({ commit }, payload) => {
  commit('SET_OVERVIEW_LOADING', payload)
}
export const clearOverview = ({ commit }) => {
  commit('CLEAR_OVERVIEW')
}

export const setMeses = ({ commit }, payload) => {
  commit('SET_MESES', payload)
}
export const setMesesLoading = ({ commit }, payload) => {
  commit('SET_MESES_LOADING', payload)
}
export const clearMeses = ({ commit }) => {
  commit('CLEAR_MESES')
}

export const setBtgDisponivel = ({ commit }, payload) => {
  commit('SET_BTG_DISPONIVEL', payload)
}
export const setBtgConexao = ({ commit }, payload) => {
  commit('SET_BTG_CONEXAO', payload)
}
export const setBtgOperacoes = ({ commit }, payload) => {
  commit('SET_BTG_OPERACOES', payload)
}
export const setBtgSaldos = ({ commit }, payload) => {
  commit('SET_BTG_SALDOS', payload || {})
}
export const clearBtg = ({ commit }) => {
  commit('CLEAR_BTG')
}
